import { LicenseInfo } from '@mui/x-license'

export const setMuiLicense = () => {
  const key = import.meta.env['VITE_MUI_LICENSE_KEY']

  if (typeof key === 'string') {
    LicenseInfo.setLicenseKey(key)
  }
}
